<template>
  <div
    v-if="show"
    id="mds-fullscreen-modal"
    :class="{ 'mds-fullscreen-modal--active': show }"
    class="mds-fullscreen-modal"
  >
    <div class="mds-fullscreen-modal__wrapper">
      <section
        aria-labelledby="title-modal"
        class="mds-fullscreen-modal__container"
        aria-hidden="true"
      >
        <div class="mds-fullscreen-modal__inner">
          <header
            :class="{ 'mds-fullscreen-modal__header--no-title': !settings.title }"
            class="mds-fullscreen-modal__header"
          >
            <h1 id="title-fullscreen-modal-1" class="mds-fullscreen-modal__title">
              {{ settings.title }}
            </h1>
            <svg class="mds-fullscreen-modal-close-btn" @click="closeFullscreenModal">
              <use xlink:href="static/mds/icons/mds.svg#remove">
                <title>Remove</title>
              </use>
            </svg>
          </header>
          <div class="mds-fullscreen-modal__content">
            <component :is="settings.component" :data="settings.data" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState({
      show: (state) => state.fullscreenModal.show,
      settings: (state) => state.fullscreenModal.settings,
    }),
  },
  methods: {
    ...mapActions({
      closeFullscreenModal: 'closeFullscreenModal',
    }),
  },
};
</script>

<style lang="scss">
.mds-fullscreen-modal {
  background-color: $fc-fullscreen-modal-background-color; // Custom color from design
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  height: 100vh;
  overflow: hidden;

  &__wrapper {
    height: calc(100% - #{$mds-space-4-x});
    margin: $mds-space-4-x auto;
    position: relative;
    width: 1040px;
  }
  &__header,
  &__container,
  &__inner {
    position: relative;
  }
  &__container,
  &__inner {
    height: 100%;
  }
  &__content {
    background-color: $mds-color-white;
    height: calc(100% - 70px); // Header
  }
  &__title {
    @include mds-level-5-heading();
    color: $mds-color-neutral-67;
    font-weight: $mds-font-weight-bold;
    margin: $mds-space-2-x 0;
  }
  &-close-btn {
    cursor: pointer;
    fill: $mds-color-neutral-67;
    height: $mds-size-element-height-m;
    position: absolute;
    top: 0;
    right: 0;
    width: $mds-size-element-height-m;
  }
}
</style>
